import { Component, Inject } from '@angular/core';
import { MatSnackBarRef, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { MediaStateService } from '@quorum/sha-media';

@Component({
  selector: 'sha-media-upload-snackbar',
  templateUrl: './media-upload-snackbar.component.html',
  styleUrls: ['./media-upload-snackbar.component.scss'],
})
export class MediaUploadSnackbarComponent {
  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: any,
    public snackBarRef: MatSnackBarRef<MediaUploadSnackbarComponent>,
    public mediaStateService: MediaStateService
  ) {}
}
